import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import CardInfoOfService from "./CardInfoServiceProvider";
import FileList from "../../../DashboardServices/PagesServicesProviders/Patients/FileList";
import toast from "react-hot-toast";
import { handleError } from "../../../../utils/handleError";
import { getFileOfUserAPI } from "../../../../services/rest/files/filesProvider";
import { useSelector } from "react-redux";
import { handleConvertMothtoString } from "../../../../components/Dashboard/ProfileUser/formatData";

const WrapFiles = ({ inforProviderContrated, typeService, setLoading }) => {
  const { _id, firstName } = useSelector((state) => state.userReducer);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [listFiles, setListFiles] = useState([]);
  const handleDateSearch = async (date) => {
    try {
      setLoading(true);
      const fecha = new Date(date);

      const dateData = {
        month: fecha.getMonth() + 1, // getMonth() devuelve 0-11, por eso sumamos 1
        year: fecha.getFullYear(),
      };
      // console.log("Buscando archivos para la fecha:", dateData);

      if (date) {
        // Se hace la peticion del archivo con la fecha seleccionada
        const responseFile = await getFileOfUserAPI({
          id_patient: _id,
          id_provider: inforProviderContrated?._id,
          dateData,
        });
        const formattedFiles = responseFile.map((url, index) => {
          // const fileName = url.split("-").pop();
          const fileName = `Reporte_${firstName}_${handleConvertMothtoString(fecha.getMonth() + 1) ?? ""}_${fecha.getFullYear() ?? ""}_${index + 1}`; // Obtiene "reporte1747757042935.pdf"
          return {
            url: url,
            name: fileName.replace(".pdf", ""), // Remueve la extensión .pdf
          };
        });

        setListFiles(formattedFiles);
      }
      setLoading(false);
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      setListFiles([]);
      toast.error(`No se pudieron obtener los archivos. \n ${message}`);
    }
  };

  useEffect(() => {
    handleDateSearch(selectedDate);
  }, [selectedDate]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
      }}
    >
      <CardInfoOfService
        healthSpecialist={inforProviderContrated}
        typeService={typeService}
      />
      <Box sx={{ width: 500 }}>
        <FileList
          setSelectedDate={(newDate) => {
            setSelectedDate(newDate);
            handleDateSearch(newDate);
          }}
          files={listFiles}
          selectedDate={selectedDate}
        />
      </Box>
    </Box>
  );
};

export default WrapFiles;
